import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { FieldLevelAccessListItemResponse, IFieldLevelAccessProperties } from '../role.types';

export const QUERY_KEY = 'GET_ROLE_BY_ID';
interface Params {
  id: string;
}

const useGetLevelAccessByIdQuery = ({ id }: Params) => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, id],
    // TODO: the type is missing
    () => api.get<FieldLevelAccessListItemResponse>(API_URL.ORGANIZATION_PROPERTIES_STATE_CONFIGS_BY_ID(id)),
    {
      enabled: !!id,
    }
  );

  const formattedData = useMemo(() => {
    if (!data) {
      return null;
    }

    return {
      id: `${data?.data.id}`,
      name: data?.data.name,
      description: data?.data.description,
      roles: data?.data.roles_applied_to,
      properties: data?.data.properties as IFieldLevelAccessProperties,
      overridableProperties: data?.data.overridable_properties as IFieldLevelAccessProperties,
    };
  }, [data]);

  return {
    isLoading,
    data: formattedData,
    isSuccess,
  };
};

export default useGetLevelAccessByIdQuery;
